"use client";
import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import Img1 from "@/assets/images/footerIMagesUnique/1.png";
import Img10 from "@/assets/images/footerIMagesUnique/10.png";
import Img11 from "@/assets/images/footerIMagesUnique/11.png";
import Img12 from "@/assets/images/footerIMagesUnique/12.png";
import Img13 from "@/assets/images/footerIMagesUnique/13.png";
import Img14 from "@/assets/images/footerIMagesUnique/14.png";
import Img15 from "@/assets/images/footerIMagesUnique/15.png";
import Img16 from "@/assets/images/footerIMagesUnique/16.png";
import Img17 from "@/assets/images/footerIMagesUnique/17.png";
import Img18 from "@/assets/images/footerIMagesUnique/18.png";
import Img19 from "@/assets/images/footerIMagesUnique/19.png";
import Img2 from "@/assets/images/footerIMagesUnique/2.png";
import Img20 from "@/assets/images/footerIMagesUnique/20.png";
import Img21 from "@/assets/images/footerIMagesUnique/21.png";
import Img22 from "@/assets/images/footerIMagesUnique/22.png";
import Img23 from "@/assets/images/footerIMagesUnique/23.png";
import Img3 from "@/assets/images/footerIMagesUnique/3.png";
import Img4 from "@/assets/images/footerIMagesUnique/4.png";
import Img5 from "@/assets/images/footerIMagesUnique/5.png";
import Img6 from "@/assets/images/footerIMagesUnique/6.png";
import Img7 from "@/assets/images/footerIMagesUnique/7.png";
import Img8 from "@/assets/images/footerIMagesUnique/8.png";
import Img9 from "@/assets/images/footerIMagesUnique/9.png";
import footerBackground from "@/assets/images/footerIMagesUnique/footerBackground.jpeg";
import { InlineDiv } from "@/common/divs";
import { AlmostBoldText, SemiBoldSpanText } from "@/common/texts";
import { PRIMARY_BUTTON_COLOR, NEUTRO_BLANK_COLOR } from "@/utils/constants";

const cityImageMapWithText: Record<
  string,
  {
    src: any;
    title: JSX.Element;
    midTitle: JSX.Element;
    subtitle1: JSX.Element;
    subtitle2: JSX.Element;
  }
> = {
  madrid: {
    src: Img1,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Madrid</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Madrid es conocida como una ciudad que alberga una gran riqueza cultural
        y una gastronomia inigualable
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más destacable es el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Parque del retiro
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Palacio Real
        </SemiBoldSpanText>
        , pero no podemos dejar fuera el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Museo del prado
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Madrid es también un gran punto de partida para visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Segovia
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Toledo{" "}
        </SemiBoldSpanText>
        y{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}> Ávila</SemiBoldSpanText>
        . ¡Que lo disfrutes!
      </SemiBoldSpanText>
    ),
  },
  barcelona: {
    src: Img2,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Barcelona</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Barcelona destaca por su arquitectura modernista y sus vistas al
        Mediterráneo
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más representativo es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Sagrada Familia
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Parque Güell
        </SemiBoldSpanText>
        , pero tampoco podemos olvidar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          las Ramblas
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Barcelona también es una excelente base para visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Montserrat
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Sitges{" "}
        </SemiBoldSpanText>
        y{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Girona
        </SemiBoldSpanText>
        . ¡Te encantará!
      </SemiBoldSpanText>
    ),
  },
  sevilla: {
    src: Img3,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Sevilla</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Sevilla es famosa por su encanto andaluz, su historia y su arte flamenco
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más emblemático es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Giralda
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Plaza de España
        </SemiBoldSpanText>
        ,aunque{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Catedral{" "}
        </SemiBoldSpanText>
        también merece una visita
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde Sevilla puedes acercarte fácilmente a{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Córdoba
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Cádiz </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}> Jerez</SemiBoldSpanText>
        . ¡No te lo pierdas!
      </SemiBoldSpanText>
    ),
  },
  granada: {
    src: Img4,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Granada</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Granada enamora con su mezcla de culturas y su ambiente joven y
        vibrante.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más imprescindible es{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Alhambra
        </SemiBoldSpanText>{" "}
        y{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          el Albaicín
        </SemiBoldSpanText>
        , pero tampoco te olvides de su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          catedral{" "}
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Es un buen punto de partida para explorar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Sierra Nevada
        </SemiBoldSpanText>{" "}
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Alpujarra{" "}
        </SemiBoldSpanText>
        . ¡Una joya del sur!
      </SemiBoldSpanText>
    ),
  },
  valencia: {
    src: Img5,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Valencia</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Valencia combina historia, playa y vanguardia como pocas ciudades
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Destacan la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Ciudad de las Artes y las Ciencias
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Lonja de la Seda
        </SemiBoldSpanText>
        , pero no te pierdas la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          playa de la Malvarrosa{" "}
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Albufera
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Xàtiva{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Peñíscola
        </SemiBoldSpanText>
        . ¡Una ciudad muy viva!
      </SemiBoldSpanText>
    ),
  },
  "valencia/valència": {
    src: Img5,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Valencia</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Valencia combina historia, playa y vanguardia como pocas ciudades
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Destacan la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Ciudad de las Artes y las Ciencias
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Lonja de la Seda
        </SemiBoldSpanText>
        , pero no te pierdas la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          playa de la Malvarrosa{" "}
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Albufera
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Xàtiva{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Peñíscola
        </SemiBoldSpanText>
        . ¡Una ciudad muy viva!
      </SemiBoldSpanText>
    ),
  },
  bilbao: {
    src: Img6,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Bilbao</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Bilbao ha sabido transformarse en una ciudad moderna sin perder su
        esencia
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más destacado es el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Museo Guggenheim
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Casco Viejo
        </SemiBoldSpanText>
        , aunque también debes probar sus famosos pintxos{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}></SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Es ideal para visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          San Juan de Gaztelugatxe
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Getxo </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          San Sebastián
        </SemiBoldSpanText>
        . ¡Muy recomendable!
      </SemiBoldSpanText>
    ),
  },
  málaga: {
    src: Img7,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Málaga</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Málaga mezcla sol, arte y buen ambiente durante todo el año
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        No te pierdas el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Museo Picasso
        </SemiBoldSpanText>{" "}
        y{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Alcazaba
        </SemiBoldSpanText>
        , aunque el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Muelle Uno{" "}
        </SemiBoldSpanText>
        también es una parada obligada
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Marbella
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Ronda </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}> Nerja</SemiBoldSpanText>
        . ¡Destino ideal todo el año!
      </SemiBoldSpanText>
    ),
  },
  malaga: {
    src: Img7,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Málaga</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Málaga mezcla sol, arte y buen ambiente durante todo el año
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        No te pierdas el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Museo Picasso
        </SemiBoldSpanText>{" "}
        y{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Alcazaba
        </SemiBoldSpanText>
        , aunque el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Muelle Uno{" "}
        </SemiBoldSpanText>
        también es una parada obligada
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Marbella
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Ronda </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}> Nerja</SemiBoldSpanText>
        . ¡Destino ideal todo el año!
      </SemiBoldSpanText>
    ),
  },
  zaragoza: {
    src: Img8,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Zaragoza</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Zaragoza es una ciudad llena de historia y con un patrimonio muy
        interesante.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más representativo es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Basílica del pilar
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Palacio de la Aljafería
        </SemiBoldSpanText>
        , aunque pasear por{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          el Ebro{" "}
        </SemiBoldSpanText>
        también es un placer
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Está bien situada para conocer{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Huesca</SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Calatayud{" "}
        </SemiBoldSpanText>
        o el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Monasterio de piedra
        </SemiBoldSpanText>
        . ¡Una sorpresa agradable!
      </SemiBoldSpanText>
    ),
  },
  córdoba: {
    src: Img9,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Córdoba</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Córdoba es una ciudad de esencua andaluza con un pasado fascinante.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más impresionante es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Mezquita-Catedral
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Alcázar de los Reyes Cristianos
        </SemiBoldSpanText>
        , aunque perderse por{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Judería{" "}
        </SemiBoldSpanText>
        es un placer
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Medina Azahara
        </SemiBoldSpanText>{" "}
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Zuheros{" "}
        </SemiBoldSpanText>
        . ¡Una ciudad que sorprende agradable!
      </SemiBoldSpanText>
    ),
  },
  cordoba: {
    src: Img9,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Córdoba</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Córdoba es una ciudad de esencua andaluza con un pasado fascinante.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más impresionante es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Mezquita-Catedral
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Alcázar de los Reyes Cristianos
        </SemiBoldSpanText>
        , aunque perderse por{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          la Judería{" "}
        </SemiBoldSpanText>
        es un placer
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Medina Azahara
        </SemiBoldSpanText>{" "}
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Zuheros{" "}
        </SemiBoldSpanText>
        . ¡Una ciudad que sorprende agradable!
      </SemiBoldSpanText>
    ),
  },
  "santiago de compostela": {
    src: Img10,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>
          Santiago de Compostela
        </AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Santiago es el destino final del Camino y una ciudad con alma
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más emblemático es su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Catedral
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Plaza del Obradoiro
        </SemiBoldSpanText>
        , aunque sus calles de piedra tienen mucho que contar{" "}
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Es una buena base para descubrir{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          A Coruña
        </SemiBoldSpanText>{" "}
        , las{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Rías Baixas{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Finisterre
        </SemiBoldSpanText>
        . ¡Una experiencia única!
      </SemiBoldSpanText>
    ),
  },
  toledo: {
    src: Img11,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Toledo</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Toledo es una ciudad-museo donde cada rincón tiene historia
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más representativo es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Catedral
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Alcázar
        </SemiBoldSpanText>
        , pero no puedes dejar de recorrer sus callejuelas medievales{" "}
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Muy cerca de{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Madrid</SemiBoldSpanText>{" "}
        , también puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Consuegra{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Aranjuez
        </SemiBoldSpanText>
        . ¡Una visita imprescindible!
      </SemiBoldSpanText>
    ),
  },
  "san sebastían/donostia": {
    src: Img12,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>
          San Sebastián
        </AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        San Sebastián destaca por su elegancia, su bahía y su cocina
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        La{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Playa de la Concha
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Monte Igueldo
        </SemiBoldSpanText>
        son imprescindibles, pero también lo es su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Casco Viejo
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Es ideal para escapadas a{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Hondarribia
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Zarautz{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          {" "}
          Francia
        </SemiBoldSpanText>
        . ¡Te encantará comer aquí!
      </SemiBoldSpanText>
    ),
  },
  salamanca: {
    src: Img13,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Salamanca</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Salamanca respira historia universitaria y momumental
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Plaza Mayopr
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Universidad
        </SemiBoldSpanText>
        son lo más icónico, aunque también merece la pena ver las{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          dos Catedrales
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Alba de Tormes{" "}
        </SemiBoldSpanText>{" "}
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Ciudad Rodrigo{" "}
        </SemiBoldSpanText>
        . ¡Una ciudad llena de vida!
      </SemiBoldSpanText>
    ),
  },
  "alicante/alacant": {
    src: Img14,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Alicante</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Alicante es sol, playa y castillos con vistas al mar.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        No puedes perderte el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Castillo de Santa Bárbara
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          paseo marítimo
        </SemiBoldSpanText>
        , aunque el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Barrio de Santa Cruz
        </SemiBoldSpanText>
        también tiene encanto
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Perfecto para conocer{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Altea </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Elche </SemiBoldSpanText>
        o la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          isla de Tabarca{" "}
        </SemiBoldSpanText>
        . ¡Muy mediterráneo!
      </SemiBoldSpanText>
    ),
  },
  burgos: {
    src: Img15,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Burgos</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Burgos es historia pura en pleno Camino de Santiago.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Catedral
        </SemiBoldSpanText>{" "}
        es lo más impresionante, pero el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Monasterio de las Huelgas
        </SemiBoldSpanText>
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          paseo por el Arlazón
        </SemiBoldSpanText>
        también valen mucho la pena
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Cerca puedes descubrir{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Atapuerca{" "}
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Lerma </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Covarrubias{" "}
        </SemiBoldSpanText>
        . ¡Muy interesante!
      </SemiBoldSpanText>
    ),
  },
  león: {
    src: Img16,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>León</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        León es acogedora y monumental, perfecta para descubir a pie.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más destacable es su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Catedral gótica
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Barrio Húmedo
        </SemiBoldSpanText>
        , aunque{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          San Isidoro
        </SemiBoldSpanText>
        también merece una visita
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde León puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Astorga{" "}
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Las Médulas{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Ponferrada{" "}
        </SemiBoldSpanText>
        . ¡Muy recomendable!
      </SemiBoldSpanText>
    ),
  },
  tarragona: {
    src: Img17,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Tarragona</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Tarragona combina historia romana y ambiente mediterráneo.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Destacan el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          anfiteatro
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          muralla romana
        </SemiBoldSpanText>
        , aunque el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          casco antiguo
        </SemiBoldSpanText>
        también tiene mucho encanto
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Perfecta para visitar el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Delta del Ebro{" "}
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Salou </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Reus </SemiBoldSpanText>.
        ¡Una ciudad con alma antigua!
      </SemiBoldSpanText>
    ),
  },
  lleida: {
    src: Img18,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>LLeida</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lleida es una ciudad tranquila con mucha historia y buenas vistas.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más representativo es la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Seu Vella
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Castillo de la Suda
        </SemiBoldSpanText>
        , aunque su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          casco antiguo
        </SemiBoldSpanText>
        también merece un paseo
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes descubrir el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Montsec{" "}
        </SemiBoldSpanText>{" "}
        , el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Congost de Mont-rebei{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Aitona en flor{" "}
        </SemiBoldSpanText>
        . ¡Muy auténtica!
      </SemiBoldSpanText>
    ),
  },
  cáceres: {
    src: Img19,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Cáceres</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Cáceres te transporta a otra época con su casco antiguo intacto.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        No puedes perderte su{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          ciudad medieval
        </SemiBoldSpanText>{" "}
        , ni la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Plaza Mayor
        </SemiBoldSpanText>
        , aunque pasear sin rumbo aquí es lo mejor.{" "}
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde Cáceres puedes conocer{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Trujillo, Mérida{" "}
        </SemiBoldSpanText>{" "}
        ,o el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Valle del Jerte{" "}
        </SemiBoldSpanText>
        . ¡Una joya extremeña!
      </SemiBoldSpanText>
    ),
  },
  cuenca: {
    src: Img20,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Cuenca</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Cuenca es famosa por sus casas colgadas y sus paisajes.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más icónico son las{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Casas Colgadas
        </SemiBoldSpanText>{" "}
        y la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Ciudad Encantada
        </SemiBoldSpanText>
        , pero también su casco antiguo es encantador{" "}
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes explorar el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Parque Natural de la Serranía{" "}
        </SemiBoldSpanText>{" "}
        . ¡Ideal para desconectar!
      </SemiBoldSpanText>
    ),
  },
  "palma de mallorca": {
    src: Img21,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Mallorca</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Mallorca es mucho más que sol y playa: es cultura, naturaleza y buen
        gusto.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        No puedes perderte la{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Catedral de Palma
        </SemiBoldSpanText>{" "}
        y{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Valldemossa
        </SemiBoldSpanText>
        , aunque las{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          calas escondidas{" "}
        </SemiBoldSpanText>{" "}
        también son un gran atractivo
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde Palma puedes visitar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Sóller{" "}
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Deià </SemiBoldSpanText>o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Cap de Formentor{" "}
        </SemiBoldSpanText>
        . ¡Una isla que enamora!
      </SemiBoldSpanText>
    ),
  },
  "santa cruz de tenerife": {
    src: Img22,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>Tenerife</AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Tenerife mezcla paisajes volcánicos, playas y pueblos con encanto.
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más impactante es{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          el Teide
        </SemiBoldSpanText>{" "}
        y sus vistas, aunque también destacan{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          La Laguna{" "}
        </SemiBoldSpanText>
        y los{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          acantilados de Los Gigantes{" "}
        </SemiBoldSpanText>
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Desde aquí puedes explorar{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>Masca </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Garachico{" "}
        </SemiBoldSpanText>
        o el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Parque Rural de Anaga{" "}
        </SemiBoldSpanText>
        . ¡Una isla llena de contrastes!
      </SemiBoldSpanText>
    ),
  },
  "las palmas": {
    src: Img23,
    title: (
      <AlmostBoldText fontSize="32px" color={NEUTRO_BLANK_COLOR}>
        Un poco sobre{" "}
        <AlmostBoldText color={PRIMARY_BUTTON_COLOR}>
          Gran Canaria
        </AlmostBoldText>
      </AlmostBoldText>
    ),
    midTitle: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Gran Canaria sorprende por su diversidad de paisajes en pocos kilómetros
      </SemiBoldSpanText>
    ),
    subtitle1: (
      <SemiBoldSpanText
        fontSize="20px"
        color={NEUTRO_BLANK_COLOR}
        style={{ lineHeight: "10px" }}
      >
        Lo más destacable son las{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Dunas de Maspalomas
        </SemiBoldSpanText>{" "}
        y el{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          casco antiguo de Vegueta{" "}
        </SemiBoldSpanText>
        , pero también merece la pena el Roque Nubio
      </SemiBoldSpanText>
    ),
    subtitle2: (
      <SemiBoldSpanText
        fontSize="20px"
        style={{ lineHeight: "10px" }}
        color={NEUTRO_BLANK_COLOR}
      >
        Es ideal para visitar {""}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Teror{" "}
        </SemiBoldSpanText>{" "}
        ,{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Tejeda{" "}
        </SemiBoldSpanText>
        o{" "}
        <SemiBoldSpanText color={PRIMARY_BUTTON_COLOR}>
          Agaete{" "}
        </SemiBoldSpanText>
        . ¡Perfecta para recorrer sin prisas!
      </SemiBoldSpanText>
    ),
  },
};

export function FooterImage() {
  const searchParams = useSearchParams();
  const cityState = searchParams.get("city");

  const cityContent = useMemo(() => {
    if (!cityState) return null;
    const key = cityState.trim().toLowerCase();
    return cityImageMapWithText[key] || null;
  }, [cityState]);

  if (!cityContent) return <></>;

  return (
    <div
      style={{
        position: "relative",
        backgroundImage: `url(${footerBackground.src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        color: "white",
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        gap: "1rem",
      }}
    >
      <div style={{ width: "100%", textAlign: "center" }}>
        {cityContent.title}
      </div>
      <InlineDiv
        className="flex-nowrap max-[750px]:flex-wrap"
        style={{
          width: "100%",
          justifyContent: "space-evenly",
          marginTop: "1rem",
        }}
      >
        <div
          className="max-[750px]:w-full w-[65%]"
          style={{
            height: "auto",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <img
            src={cityContent.src.src}
            alt={cityState ?? "City Image"}
            style={{
              width: "85%",
              height: "auto",
            }}
          />
        </div>
        <div
          style={{
            marginLeft: "2.5%",
            marginRight: "5%",
            textAlign: "center",
            marginTop: "1rem",
          }}
        >
          <div>{cityContent.midTitle}</div>
          <div style={{ marginTop: "2rem" }}>{cityContent.subtitle1}</div>
          <div style={{ marginTop: "2rem" }}>{cityContent.subtitle2}</div>
        </div>
      </InlineDiv>
    </div>
  );
}
